import Vue from 'vue';
import EntryDialogCard from './entry-dialog-card.vue';
import getErrorTip from '@/natives/libs/request/getErrorTip';
import handleErrorAndTip from '@/natives/libs/request/handleErrorAndTip';
import useEventBus from '@/natives/libs/hooks/useEventBus';
const entryDialogCardEvent = useEventBus('entry-dialog-card-load');
import HUI from 'hui-intl';
import HUIPlugin from '@/Common/plugins/hui';
import CloudT from '@/Common/components/cloud-t.vue';
import InputLimit from '@/Common/plugins/input-limit';

const ComponentsVue = {
  instance: null,
  init(el, { mixins, i18n, api, buryPoint }) {
    if (this.instance) {
      return this.instance;
    }
    Vue.prototype.$bury = buryPoint;
    Vue.prototype.$api = api;
    // Vue.prototype.$i18n = i18n;
    Vue.prototype.$getErrorTip = getErrorTip(i18n);
    Vue.prototype.$handleErrorAndTip = handleErrorAndTip(i18n);
    Vue.mixin(mixins);
    Vue.component('T', CloudT);
    Vue.use(InputLimit);
    Vue.use(HUIPlugin);
    Vue.use(HUI, {
      i18n: (key, value) => {
        let locale = i18n.t(key);
        if (value) {
          for (let name in value) {
            locale = locale.replace(`{${name}}`, value[name]);
          }
        }
        return locale;
      }
    });

    this.instance = new Vue({
      i18n,
      render: (h) => h(EntryDialogCard)
    }).$mount(el).$children[0];

    return this.instance;
  }
};

entryDialogCardEvent.ComponentsVue = ComponentsVue;
entryDialogCardEvent.emit(ComponentsVue);
